'use client';

import {
  matchVoiceCommand,
  useVoiceCommands,
} from '@/src/lib/use-voice-commands';
import { showToast } from '@/src/components/ui-kontora/use-toast';

export function VoiceCommandTrigger() {
  const { state, start, stop } = useVoiceCommands((final) => {
    const cmd = matchVoiceCommand(final);
    if (cmd) {
      showToast({
        variant: 'success',
        title: 'Sprachbefehl erkannt',
        description: cmd,
      });
    } else {
      showToast({
        variant: 'warning',
        title: 'Kein Befehl erkannt',
        description: final,
      });
    }
  });

  if (state === 'unsupported') {
    return (
      <span
        data-tour="voice-unsupported"
        className="text-[10px] text-[var(--k-color-text-muted)]"
        title="Dein Browser unterstützt keine Spracherkennung"
      >
        🎙 —
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={state === 'listening' ? stop : start}
      aria-pressed={state === 'listening'}
      aria-label="Sprachbefehl"
      data-tour="voice-trigger"
      className={`inline-flex h-9 w-9 items-center justify-center rounded-full border transition ${
        state === 'listening'
          ? 'border-[var(--k-color-danger)] bg-[var(--k-color-danger)] text-[var(--k-color-text-primary)] animate-pulse'
          : 'border-[var(--k-color-border-default)] bg-[var(--k-color-surface)] text-[var(--k-color-text-secondary)]'
      }`}
    >
      🎙
    </button>
  );
}
